import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import user from './user';
import users from './users';
import places from './places';
import snacks from './snacks';
import reports from './reports';
import contracts from './contracts';
import conversations from './conversations';
import feed from './feed';
import accounts from './accounts';
import ui from './ui';
import support from './support';
import forum from './forum';
import expenses from './expenses';
import communication from './communication';

const reducers = () =>
   combineReducers({
      form,
      user,
      snacks,
      places,
      reports,
      ui,
      users,
      conversations,
      contracts,
      accounts,
      feed,
      support,
      forum,
      expenses,
      communication,
   });

export default reducers;
